export default class CommissionRateStatusUpdateItem {
  constructor() {
    this.ServiceIds = [];
    this.StatusId = null;
    this.OldStatusId = null;
    this.UserId = null;
    this.allItemsInTheSearchSetAreSelected = null;
    this.searchItem = null;
  }
}
